import React, { useEffect, useState } from "react";
import { MenuLateral } from "../../../../Components/MenuLateral/Index";
import {
  Box,
  Container,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import theme from "../../../../Styles/theme";
import { Header } from "../../../../Components/Header";
import { usePrefeitura } from "../../../../Hooks/usePrefeitura";
import { useLocation, useNavigate } from "react-router";
import axios from "axios";
import { ModalLoader } from "../../../../Components/ModalLoader";
import api from "../../../../Services/api";
import { Panel } from "./Panel";
import {
  Notificacao,
  NotificacaoComponent,
} from "../../../../Components/Notificacao";

export const Pesquisar: React.FC = () => {
  const [municipio, setMunicipio] = useState<string>("0");
  const [pesquisa, setPesquisa] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [guias, setGuias] = useState<any[]>([]); // Alterado para array
  const [guiaFocus, setGuiaFocus] = useState({});
  const { prefeituras, getPrefeituras } = usePrefeitura();
  const [notificacao, setNotificacao] = useState({
    mensagem: "",
    tipo: "AVISO",
  } as Notificacao);
  const location = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    getPrefeituras();
  }, [location]);

  // Filtrar apenas as prefeituras ativas
  const prefeiturasAtivas = prefeituras.filter(
    (prefeitura) => prefeitura.STATUS && prefeitura.STATUS.trim() === "A"
  );

  const handleSearch = async () => {
    setGuias([]);
    if (!municipio || !pesquisa.trim()) {
      setNotificacao({
        mensagem:
          "Por favor, selecione um município e insira um valor para pesquisa.",
        tipo: "ATENCAO",
      });
      return;
    }

    try {
      setLoading(true);
      const response = await api.post("/pesquisa", {
        prefeitura_id: municipio,
        pesquisa: pesquisa
          .trim()
          .replaceAll("-", "")
          .replaceAll(".", "")
          .replaceAll("/", "").replaceAll("'", ""),
      });
      setGuias(response.data);
      setNotificacao({
        mensagem:
          "Guias encontradas a partir do termo de pesquisa: " + pesquisa,
        tipo: "SUCESSO",
      });
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
      setNotificacao({
        mensagem:
          "Não foi possível pesquisar guias referentes ao termo de pesquisa: " +
          pesquisa,
        tipo: "ERRO",
      });
      window.alert("ERRO DE REDE!")
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <MenuLateral titulo={"PESQUISAR GUIA de ITBI"} />
      <Container maxWidth="md">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          padding={4}
        >
          <Header type={"Pesquisar Guia de ITBI"} />
          <FormControl
            variant="outlined"
            style={{
              margin: "16px",
              minWidth: "200px",
              width: "100%",
              maxWidth: "500px",
              marginTop: "6vh",
            }}
          >
            <InputLabel id="municipio-label">Município</InputLabel>
            <Select
              labelId="municipio-label"
              value={municipio}
              onChange={(ev) => setMunicipio(ev.target.value)}
              label="Município"
            >
              {prefeiturasAtivas.map((prefeitura) => (
                <MenuItem key={prefeitura.ID} value={prefeitura.ID}>
                  {prefeitura.NOME}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            variant="outlined"
            label="Adquirente,Transmitente,Cpf ou Cnpj"
            value={pesquisa}
            onChange={(ev) => setPesquisa(ev.target.value)}
            style={{
              margin: "16px",
              width: "100%",
              maxWidth: "500px",
            }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleSearch}
            style={{ marginTop: "16px" }}
          >
            Buscar
          </Button>
        </Box>
      </Container>

      <div
        style={{
          width: "100vw",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "15vh",
        }}
      >
        <TableContainer
          component={Paper}
          style={{ marginTop: "24px", width: "95vw" }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    fontWeight: "bold",
                    fontSize: "small",
                    textAlign: "center",
                  }}
                >
                  Número
                </TableCell>
                <TableCell
                  style={{
                    fontWeight: "bold",
                    fontSize: "small",
                    textAlign: "center",
                  }}
                >
                  Localização
                </TableCell>
                <TableCell
                  style={{
                    fontWeight: "bold",
                    fontSize: "small",
                    textAlign: "center",
                  }}
                >
                  Avaliado
                </TableCell>
                <TableCell
                  style={{
                    fontWeight: "bold",
                    fontSize: "small",
                    textAlign: "center",
                  }}
                >
                  Município
                </TableCell>
                <TableCell
                  style={{
                    fontWeight: "bold",
                    fontSize: "small",
                    textAlign: "center",
                  }}
                >
                  Cartório
                </TableCell>
                <TableCell
                  style={{
                    fontWeight: "bold",
                    fontSize: "small",
                    textAlign: "center",
                  }}
                >
                  Transmitente
                </TableCell>
                <TableCell
                  style={{
                    fontWeight: "bold",
                    fontSize: "small",
                    textAlign: "center",
                  }}
                >
                  Adquirente
                </TableCell>
                
                <TableCell
                  style={{
                    fontWeight: "bold",
                    fontSize: "small",
                    textAlign: "center",
                  }}
                ></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {guias.map((guia) => (
                <TableRow key={guia.ID}>
                  <TableCell style={{ fontSize: "small", textAlign: "center" }}>
                    {guia.NUMERO}/{guia.ANO}
                  </TableCell>
                  <TableCell style={{ fontSize: "small", textAlign: "left" }}>
                    {guia.LOCALIZACAO}
                  </TableCell>
                  <TableCell style={{ fontSize: "small", textAlign: "center" }}>
                    {new Date(guia.AVALIADO).toLocaleDateString("pt-BR")}
                  </TableCell>
                  <TableCell style={{ fontSize: "small", textAlign: "center" }}>
                    {guia.MUNICIPIO}
                  </TableCell>
                  <TableCell style={{ fontSize: "small", textAlign: "left" }}>
                    {guia.CARTORIO}
                  </TableCell>
                   <TableCell style={{ fontSize: "small", textAlign: "left" }}>
                    {guia.TRANSMITENTE}
                  </TableCell>
                  <TableCell style={{ fontSize: "small", textAlign: "left" }}>
                    {guia.ADQUIRINTE}
                  </TableCell>
                 
                  <TableCell
                    style={{
                      fontSize: "small",
                      textAlign: "center",
                      color: theme.colors.primary,
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                    onClick={() => {
                      navigate(`/itbi/pesquisar/?guia=${!!guia.ISRURAL?"rural":"urbano"}`);
                      setGuiaFocus(guia);
                    }}
                  >
                    VISUALIZAR
                  
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <Panel guiaFocus={guiaFocus} onClose={() => setGuiaFocus({})} />
      <ModalLoader loading={loading} />
      <NotificacaoComponent
        notificacao={notificacao}
        setNotificacao={setNotificacao}
      />
    </>
  );
};
